import React from "react";
import T from "prop-types";
import { get, merge } from "lodash";
import {
  ATTACHMENT_IDS,
  ATTACHMENT_TYPES
} from "MODULES/OutgoingQuotes/constants";
import { ATTACHMENT_TYPES as SALES_ORDER_ATTACHMENT_TYPES } from "MODULES/SalesOrders/constants";
import { shortDate } from "LIB/formatters/date";

const Row = ({ attachment, ids, setFieldValue }) => {
  const toggle = () => {
    if (ids.includes(attachment.id)) {
      const index = ids.indexOf(attachment.id);
      ids.splice(index, 1);
      setFieldValue(ATTACHMENT_IDS)(ids);
    } else {
      ids.push(attachment.id);
      setFieldValue(ATTACHMENT_IDS)(ids);
    }
  };

  return (
    <tr>
      <td />
      <td>
        <input
          type="checkbox"
          selected={ids.includes(attachment.id)}
          onClick={toggle}
        />
      </td>
      <td>{attachment.name}</td>
      <td>
        {get(
          merge(ATTACHMENT_TYPES, SALES_ORDER_ATTACHMENT_TYPES),
          `${attachment.attachment_type}.label`
        )}
      </td>
      <td>{attachment.description}</td>
      <td>{shortDate(attachment.created_at)}</td>
      <td>{get(attachment, "created_by.full_name")}</td>
    </tr>
  );
};

Row.propTypes = {
  attachment: T.shape({}),
  ids: T.arrayOf(T.number),
  setFieldValue: T.func.isRequired
};

const SelectAttachmentTable = ({
  attachments,
  getFieldValue,
  setFieldValue
}) => {
  const ids = getFieldValue(ATTACHMENT_IDS);

  return (
    <table
      className="table table-striped table-hover table-numbered"
      style={{ marginTop: 20 }}
    >
      <thead>
        <tr>
          <th />
          <th />
          <th>Name</th>
          <th>Type</th>
          <th>Description</th>
          <th>Date Added</th>
          <th>Added By</th>
        </tr>
      </thead>
      <tbody>
        {attachments.map(a => (
          <Row attachment={a} ids={ids} setFieldValue={setFieldValue} />
        ))}
      </tbody>
    </table>
  );
};

SelectAttachmentTable.propTypes = {
  attachments: T.arrayOf(T.shape({})),
  getFieldValue: T.func.isRequired,
  setFieldValue: T.func.isRequired
};

export default SelectAttachmentTable;



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/Detail/Send/SelectAttachmentTable.jsx